console.log('1926 start');

$(document).ready(function () {




	// $('.rSide .simplebar-content-wrapper').on('mouseover',()=>{
	// 	if ($('.rSide .simplebar-content-wrapper')[0].scrollTop > 50) {
	// 		$('.news-block').addClass('scroll')
	// 	} else $('.news-block').removeClass('scroll')
	// })
	//
	// $('.rSide .simplebar-content-wrapper').on('mouseout',()=>{
	// 	if ($('.rSide .simplebar-content-wrapper')[0].scrollTop > 50) {
	// 		$('.news-block').addClass('scroll')
	// 	} else $('.news-block').removeClass('scroll')
	// })


	const $topHomeSlider = $('.topHomeSlider')
	if($topHomeSlider[0]) {
		const colSl = $topHomeSlider[0].dataset.endPosition*1;
		let durat = $topHomeSlider[0].dataset.duration*1000;
		let position = $topHomeSlider[0].dataset.position*1;

		let slTopInterval = setInterval(() => {
			topSliderStart();
		},durat)


		$topHomeSlider.on('mouseout',()=>{//stop slider
			clearInterval(slTopInterval);
			slTopInterval = setInterval(() => {
				topSliderStart();
			},durat)
		})

		$topHomeSlider.on('mouseover',()=>{
			clearInterval(slTopInterval);
		})

		$('.progBox div').click(function (){
			let target = $(this).attr('data-target') - 1;
			target = (target >= colSl) ? 1 : target+1;
			topSliderStart(target);
		})

		function topSliderStart (target = position) {
			$topHomeSlider.addClass('trsp anim')
			// setTimeout(() => {$topHomeSlider.removeClass('anim')},1050)
			setTimeout(() => {
				$topHomeSlider.removeClass('sl'+(position))
				if(position!==target) position = target-1;
				position = (position >= colSl) ? 1 : position+1;

				// $topHomeSlider.addClass('sl'+ position).removeClass('trsp').attr('data-position',position)
				$topHomeSlider.addClass('sl'+ position).removeClass('trsp anim').attr('data-position',position)
			},2050)
			// setTimeout(() => {$topHomeSlider.removeClass('trsp')},3050)

			fundMetSlide($('.cardBox .itms'));
		}

	}
});

$( document ).ready(function() {


	if ($(window).width() >= 768) {
		if ($('.randBoxBann')[0]) randSlider($('.randBoxBann'));

	} else {

		// let responsivSett = {
		// 	0 : {
		// 		items: 1,
		// 	}
		// };
		// responsivSett[cssBreakPoints.xs] = {
		// 	items: 2
		// };
		// responsivSett[cssBreakPoints.sm] = {
		// 	items: 3
		// };
		$('.randBoxBann .slider').owlCarousel({
			margin: 30,
			rtl: rtl,
			autoWidth:true,
			dots: false,
			loop: true,
			autoplay: true,
			autoplayTimeout: 4000,
			nav: true,
		});
	}

	if($window.width()<=1030.9) {
		$('.company-news').on('click',()=>{
			window.location = '/swiss/english/about/ournews/';
		})
	}





});

// if($('.block-margin .tab-content')[0]){
// 	new SimpleBar($('.block-margin .tab-pane')[0]);
// 	new SimpleBar($('.block-margin .tab-pane')[1]);
// }

if($('.cardBox')[0]) {
	let left = $('.cardBox .wr')[2].getBoundingClientRect().left - $('.cardBox .wr')[1].getBoundingClientRect().left;
	$('.cardBox .itms').css({'--lft':left+'px'});
}

(function () {
	if (window.randSliderInitialized) return;
	window.randSliderInitialized = true;

	function randSlider(sl) {
		// Calculate number of visible items based on container width dynamically
		const ct = 6;
		const rBlk = sl.find('.itm');
		const clbz = rBlk.length;
		let norep = 0;



		if (clbz < ct * 2) {
			console.warn('Not enough items to perform the desired operation. Ensure there are sufficient items in the slider.');
			return;
		}

		// Assign unique data-counter to each item
		rBlk.each((i, el) => {
			el.setAttribute('data-counter', i + 1);
		});


		function getRandomNumber(max, exclude) {
			let num;
			do {
				num = Math.floor(Math.random() * max) + 1;
			} while (num === exclude);

			return num;
		}

		function change() {

			const oldnumber = getRandomNumber(ct, norep);
			const number = Math.floor(Math.random() * (clbz - ct)) + ct + 1;



			const oldEl = sl.find(`[data-counter="${oldnumber}"]`);
			const newEl = sl.find(`[data-counter="${number}"]`);

			if (oldEl.length && newEl.length) {
				oldEl.addClass('op').css({ transition: 'opacity 0.4s ease', opacity: 0 });
				newEl.addClass('op').css({ transition: 'opacity 0.4s ease', opacity: 1 });


				setTimeout(() => {
					newEl.addClass('first').attr('data-counter', oldnumber);
					oldEl.not('.first').attr('data-counter', number);
				}, 600);

				setTimeout(() => {
					rBlk.removeClass('op first');
					norep = oldnumber;
				}, 1000);
			} else {
				console.warn('Element not found for the given data-counter during change operation. OldEl length:', oldEl.length, 'NewEl length:', newEl.length);
			}
		}

		// Set interval to change items
		let slRandInterval = setInterval(change, 4000);


		// Stop interval on mouseover, restart on mouseout
		sl.on('mouseover', () => {
			clearInterval(slRandInterval);

		});
		sl.on('mouseout', () => {
			slRandInterval = setInterval(change, 4000);

		});

		let oldrandCh = 0;

		// Reload button functionality
		sl.find('.reload').on('click', () => {

			if (clbz <= ct) {
				console.warn('Not enough items to perform the reload operation. Ensure there are sufficient items in the slider.');
				return;
			}

			// Shuffle all items to assign new data-counter values
			let shuffledIndexes = Array.from({ length: clbz }, (_, i) => i + 1);
			shuffledIndexes = shuffledIndexes.sort(() => Math.random() - 0.5);

			rBlk.each((i, el) => {
				$(el).css({ transition: 'opacity 0.4s ease', opacity: 0 });
				setTimeout(() => {
					el.setAttribute('data-counter', shuffledIndexes[i]);
					$(el).css({ opacity: 1 });
				}, 400);
			});

			oldrandCh = shuffledIndexes[0]; // Update the oldrandCh to the new starting point

			setTimeout(() => {
				rBlk.removeClass('op first');
			}, 1400); // Further increased timeout to ensure all animations are complete
		});
	}

	function fundMetSlide(sl) {

		const $wr = sl.find('.wr');
		const cWr = $wr.length;

		$wr.each((i, el) => {
			const c = parseInt(el.getAttribute('data-counter'));
			el.setAttribute('data-counter', c <= 1 ? cWr : c - 1);

		});

		// Add animation class
		sl.addClass('anim');
		setTimeout(() => {
			sl.removeClass('anim');

		}, 2000);
	}

	window.randSlider = randSlider;
	window.fundMetSlide = fundMetSlide;
})();



(function($) {
	$(function() {
		const mainSliderCarousel = $(".main-slider").owlCarousel({
			rtl: rtl,
			items: 1,
			loop: true,
			autoplay: true,
			autoplayTimeout: 5000,
			autoplayHoverPause: true,
			animateOut: 'fadeOut',
			animateIn: 'fadeIn',
			lazyLoad: true,
		});
		pauseFirstSlide();

		function pauseFirstSlide() {
			mainSliderCarousel.trigger('stop.owl.autoplay');
			setTimeout(function() {
				mainSliderCarousel.trigger('play.owl.autoplay');
			}, 9000);
		}

		mainSliderCarousel.on('changed.owl.carousel', function(e) {

			if (e.page.index === 0) {
				pauseFirstSlide();
			}

		});

		$('.platform-block .owl-carousel').owlCarousel({
			items: 1,
			loop: true,
			autoplay: true,
			autoplayTimeout: 5000,
			autoplayHoverPause: true,
			animateOut: 'fadeOut',
			animateIn: 'fadeIn',
			lazyLoad: true,
			dots: false,
			nav: false
		});
		if($('.custom-scroll')[0]){
			new SimpleBar($('.custom-scroll')[0]);

			$('.rSide .simplebar-content-wrapper').scroll(function (){
				console.log('scroll');

				if ($('.rSide .simplebar-content-wrapper')[0].scrollTop > 50) {
					$('.news-block').addClass('scroll')
				} else $('.news-block').removeClass('scroll')
			})
		}

	});
	$window.on('load', function() {
		let slidersComplete;
		if ($('.home-page').length) {
			//Trading ideas


			$.ajax({
				type: 'POST',
				url: 'https://www.dukascopy.com/tv/api/ti',
				dataType: 'json',
				data: {
					action: 'get',
					lang: globalLang,
					limit: 12
				},
				complete: function() {
					// slidersComplete[0] = true;
				},
				success: function(res) {
					let config = {
							'EUR/USD': 111,
							'USD/JPY': 114,
							'GBP/USD': 113,
							'Gold': 185,
							'DUK+': 220
						},
						ideasList = $('#trading-ideas'),
						dcTrNavTabs = ideasList.find('.nav-tabs'),
						tabTemplate = dcTrNavTabs.children(),
						dcTabContent = ideasList.find('.tab-content'),
						tabPaneTemlate = dcTabContent.children(),
						tab,
						tabPane,
						active = true;//To activate first tab


					$.each(config, function(name, id) {
						if (res[id]) {
							tab = (active) ? tabTemplate.clone().addClass('active') : tabTemplate.clone();
							tab.children().attr('href', '#tab-' + id).html(name);
							dcTrNavTabs.append(tab);

							//Tabs content
							tabPane = (active)
								? tabPaneTemlate.clone().attr('id', 'tab-' + id).addClass('active')
								: tabPaneTemlate.clone().attr('id', 'tab-' + id);

							tabPane.find('.trading-ideas-slider').html('');
							let slides = tabPane.find('.trading-ideas-slider');

							$.each(res[id], function(index, newsBlock) {
								item = `<div class="text">
											<div class="title-block"><span class="time">${newsBlock.date}</span>
												<h3><a href="${newsBlock.url}" class="title">${newsBlock.title}</a></h3>
											</div>
											<p><a href="${newsBlock.url}" class="descr text-cut">${newsBlock.text}</a></p>
										</div>`
								slides.append(item);
							});
							dcTabContent.append(tabPane);
							active = false;
						}
					});
					tabTemplate.remove();
					tabPaneTemlate.remove();
					$('.trading-ideas-slider').owlCarousel({
						margin: 30,
						items: 2,
						responsive:{
							0:{
								items: 1,
								autoWidth:true,
								loop: true,
							},
							768:{
								items:2,
								loop: true,
							},
						},
						rtl: rtl,
						dots: false,
						onInitialized: checkIfPossibleToDrag
					});
					arrowsHandler($('.trading-ideas'));
				},
				error: function(err) {
					console.log('tradingidea api error', err);
				}
			});
			//Market research slider
			$.ajax({
				type: 'POST',
				url: 'https://www.dukascopy.com/tv/api/marketresearch',
				dataType: 'json',
				data: {
					action: 'get',
					lang: globalLang
				},
				success: function(res) {
					let mrProdSlider = $('#mr-product-slider'),
						mrProdGroup = $('.mr-products'),
						itemTemplate = mrProdSlider.children(),
						item;

					if (res.length) {
						$.each(res, function(key, val) {
							let urlPart = itemTemplate.data('src');
							item = itemTemplate.clone().attr({
								'href': val.url,
								'style': `background-image: url(${urlPart + val.abbr}.jpg);`
							}).addClass('mr-' + val.abbr);

							item.find('h3').html(val.category);
							mrProdSlider.append(item);
						});
						itemTemplate.remove();

					} else {
						mrProdGroup.addClass('hidden');
					}
				},
				error: function(err) {
					console.log('marketresearch api error', err);
				}
			});
			//Videos slider
			$.ajax({
				type: 'POST',
				url: 'https://www.dukascopy.com/tv/api/video',
				dataType: 'json',
				data: {
					action: 'startpage',
					lang: globalLang,
					limit: 8
				},
				success: function(res) {
					console.log('##### tv #### 3 ');
					let activeTabIndex = 3;
					let dcTv = $('#dc-tv'),
						dcTvNavTabs = dcTv.find('.nav-tabs'),
						tabTemplate = dcTvNavTabs.children(),
						dcTvTabContent = dcTv.find('.tab-content'),
						tabPaneTemlate = dcTvTabContent.children(),
						tab,
						tabPane,
						itemThumb,
						itemText,
						active = true;//To activate first tab
					$.each(res.video, function(index, val) {
						if (val.length) {
							// //Tab titles
							// tab = (active) ? tabTemplate.clone().addClass('active') : tabTemplate.clone();
							// tab.children().attr('href', '#tab-' + res.title[index].id).html(res.title[index].name);
							// dcTvNavTabs.append(tab);
							// //Tabs content
							// tabPane = (active) ? tabPaneTemlate.clone().attr('id', 'tab-' + res.title[index].id).addClass('active') : tabPaneTemlate.clone().attr('id', 'tab-' + res.title[index].id);

							tab = (index === activeTabIndex) ? tabTemplate.clone().addClass('active') : tabTemplate.clone();
							tab.children().attr('href', '#tab-' + res.title[index].id).html(res.title[index].name);
							dcTvNavTabs.append(tab);

							tabPane = (index === activeTabIndex)
								? tabPaneTemlate.clone().attr('id', 'tab-' + res.title[index].id).addClass('active')
								: tabPaneTemlate.clone().attr('id', 'tab-' + res.title[index].id);

							let thumbContainer = tabPane.find('.thumb-slider'),
								thumbTemlate = thumbContainer.children(),
								textContainer = tabPane.find('.text-slider'),
								textTempate = textContainer.children();
							$.each(res.video[index], function(index, videoInfo) {
								itemThumb = thumbTemlate.clone();
								itemText = textTempate.clone();
								//itemThumb.children().attr('src', videoInfo.sthumb.replace('|148', '|270'));
								itemThumb.children().attr({
									'data-src': videoInfo.sthumb.replace('|148', '|449')
								});//For lazy load
								itemText.find('.date').text(videoInfo.date);
								itemText.find('.title').text(videoInfo.title).add(itemThumb).attr('href', 'https://www.dukascopy.com/tv/' + videoInfo.lang + '/view/' + videoInfo.id + '#0');
								thumbContainer.append(itemThumb);
								textContainer.append(itemText);
							});
							dcTvTabContent.append(tabPane);
							thumbTemlate.remove();
							textTempate.remove();
							active = false;
						}
					});
					tabTemplate.remove();
					tabPaneTemlate.remove();
					// slidersComplete[2] = true;
					dcTv.find('.open-video').on('click', function(e) {
						e.preventDefault();
						window.open($(this).attr('href'),
							'videoPlay',
							'width=700,height=750,scrollbars=yes,resizable=yes');
					});
					let responsivSett = {
						0 : {
							items: 8,
							autoWidth:true,

						}
					};
					responsivSett[cssBreakPoints.sm] = {
						items: 2
					};
					responsivSett[cssBreakPoints.md] = {
						items: 4
					};
					$('.dc-tv-slider').owlCarousel({
						margin: 30,
						rtl: rtl,
						responsive : responsivSett,
						onInitialized: checkIfPossibleToDrag,
						lazyLoad: true,
						loop: true,
						dots: false
					});
					arrowsHandler($('.dc-tv'));

					//To position arrows on .dc-tv-slider in correct way it was needed to separate img and description on different carousels
					$('.dc-tv .tab-pane').each(function() {
						let tabPane = $(this);
						tabPane.find('.dc-tv-slider').on('dragged.owl.carousel', function(event) {
							tabPane.find('.dc-tv-slider').trigger('to.owl.carousel', [event.item.index,300,true]);
						});
					});

					setTimeout(function () {
						dcTvNavTabs.find('li a[data-toggle="tab"]').eq(activeTabIndex).trigger('click');
					}, 0);

				},
				error: function(err) {
					console.log('video api error', err);
				}
			});

			function arrowsHandler(sliderBlock) {
				//clearInterval(arrowsHandlerTimer);
				//Nav arrows and carousels sliding
				const NextBtns = sliderBlock.find('.owl-next'),
					PrevBtns = sliderBlock.find('.owl-prev');
				NextBtns.on('click', function() {
					$(this).parents('.owl-carousel-group').find('.owl-carousel').trigger('next.owl.carousel');
				});
				PrevBtns.on('click', function() {
					$(this).parents('.owl-carousel-group').find('.owl-carousel').trigger('prev.owl.carousel');
				});
			}
		}
	});
	function checkIfPossibleToDrag(event) { //If not enoght items - don't show arrows
		if (event.item.count <= event.page.size) {
			$(event.target).parents('.navigation-check').addClass('nothing-to-drag');
			setTimeout(function(){$(event.target).trigger('refresh.owl.carousel')}, 1000);
		}
	}
})(jQuery)